import { bus_nhaxe } from '../../models/response/bus/bus_nhaxe';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_NHAXE_PATH = "bus/nha-xe";

class BusNhaXeApi extends BaseCRUDApi<bus_nhaxe> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busNhaXeApi = new BusNhaXeApi(API_BUS_NHAXE_PATH);
